import apiFetch from '../apiFetch'

export default function (documentId, organizedUnitId, token) {
  return apiFetch({ endPoint: `Document/${documentId}/Download?organizedUnitId=${organizedUnitId}`, parseBlobAndAssign: true, method: 'GET', body: null, token: token })
}
